import { addClassDuringActivity } from 'utilities/dom';
import { getAllRetailStoreRegions, getPickupStores, updateMyStore } from 'features/bopus/api';
import { trimFieldValue } from 'ui/forms';

(function () {

	const { bopus } = window.lp;
	const templateFolder = '/product/templates/';

	// for caching store regions data (which doesn't change often) per page load
	let storeRegionsData = null;

	bopus.ChangePickupOptionsView = Backbone.Marionette.ItemView.extend({
		el: '#changeStoreModal',
		template: `${templateFolder}/changeStore`,
		ui: {
			jsStorePickupList: '.jsStorePickupList',
			jsZipForStore: '.jsZipForStore',
			jsStoreZipApply: '.jsStoreZipApply',
			jsUpdateStorePickupBtn: '.jsUpdateStorePickupBtn',
			jsStoreRegions: '.jsStoreRegions',
			jsZipFormStorePickup: '.jsZipFormStorePickup'
		},
		events: {
			'click @ui.jsStoreZipApply': 'applyStorePickupZip',
			'keydown @ui.jsZipForStore': 'detectEnterKey',
			'click @ui.jsUpdateStorePickupBtn': 'saveSelectedStorePickup',
			'change @ui.jsStoreRegions': 'showStoreRegions',
			'focus @ui.jsStoreRegions': 'resetFormValidation',
			'click @ui.jsStoreRegions': 'resetFormValidation'
		},
		initialize () {

			const that = this;

			// store pickup update listener
			this.model.listenToOnce(this.model, 'changeStore', (e, selectedStore) => {

				const request = updateMyStore(selectedStore).then((response) => {

					const store = response.ApiResult;
					$('.pickupDate').html(store.StoreArrivalDate);
					$('.pickupStoreName').html(`${store.StoreName} Store`);
					$('#storePickupRadio').val(store.StoreNumber);
					$('.needItToday').attr('data-zip', store.ZipCode);
					$('.changeStore').attr('data-store', `${store.StoreName} #${store.StoreNumber}`);

				});

				addClassDuringActivity(document.body, 'loading', request);

			});

			$(bopus)
				.off('storeSelected')
				.on('storeSelected', () => {

					that.setSubmitButtonState(true);

				});

		},
		onRender () {

			const that = this;
			$('body').lpModal({
				onInit: true,
				appendContentToForm: false,
				content: this.$el,
				height: 653,
				width: 793,
				closeEvt () {

					that.$el.empty();
					that.stopListening();
					that.undelegateEvents();

				}
			});

			this.loadTabDynamicContent();

			// initialize jQuery validation on Zip Code field
			window.initFormValidation(
				true,
				'.jsZipFormStorePickup',
				$.extend(
					{},
					{
						onfocusout: trimFieldValue,
						onsubmit: false,
						success: null
					}
				)
			);

			// add own validation rules for Store Zip Code fields
			this.ui.jsZipForStore.rules('add', {
				required: true,
				number: true,
				minlength: 5 // zip has maxlength attribute, so no need to add maxlength rule
			});

			// numeric input only for Store Pickup
			this.ui.jsZipForStore.inputFilter();

		},
		resetFormValidation () {

			// reset existing validation error
			this.ui.jsZipFormStorePickup.validate().resetForm();

		},
		applyStorePickupZip (e) {

			e.stopImmediatePropagation();

			const that = this;
			const zipCode = this.validateAndGetZip(this.ui.jsZipForStore);

			if (zipCode) {

				const data = {
					ZipCode: zipCode,
					PickupStoreNumber: this.model.get('PickUpStoreNumber'),
					ShortSku: this.model.get('ShortSku')
				};
				this.showStorePickupList(data).done(() => {

					that.ui.jsStoreRegions.val('');
					that.setSubmitButtonState(false);

				});

			}

		},
		validateAndGetZip ($zipCodeField) {

			const zipCode = $zipCodeField.val();
			const validZip = $zipCodeField.valid() && zipCode;

			if (!validZip) {

				$zipCodeField.focus();

			}
			return validZip;

		},
		detectEnterKey (e) {

			if (e.which === 13) {

				$(e.target).siblings('.delivery-options__zipBtn').click();

				e.stopImmediatePropagation();
				return false;

			}
			return true;

		},
		loadTabDynamicContent () {

			const that = this;

			if (this.ui.jsStorePickupList.is(':empty')) {

				const data = {
					ZipCode: '',
					PickupStoreNumber: this.model.get('PickUpStoreNumber'),
					ShortSku: this.model.get('ShortSku')
				};
				this.showStorePickupList(data);

			}

			this.showStoreRegionsDropdown();

		},
		showStorePickupList (data) {

			const that = this;
			return getPickupStores(data).then((response) => {

				const responseModelJson = response.GlobalCartResponseModel;
				if (that.storePickupOptionsView) {

					that.storePickupOptionsView.collection.set(responseModelJson.Stores, { remove: true });

				} else {

					that.storePickupOptionsView = new bopus.StorePickupOptionsView({
						collection: new Backbone.Collection(responseModelJson.Stores),
						selectedStoreNumber: that.model.get('PickUpStoreNumber'),
						includeStoreNumber: false
					});

				}

				let noStoresView;
				if (responseModelJson.WithinRange) {

					noStoresView = new bopus.NoStoresView();

				} else {

					noStoresView = new bopus.NoStoresView({
						model: new Backbone.Model({
							zipCode: data.ZipCode
						})
					});

				}

				noStoresView.render();
				that.storePickupOptionsView.render();

			});

		},
		saveSelectedStorePickup (e) {

			e.stopImmediatePropagation();

			const $selectedShippingOptionRadio = this.$el.find('.jsStorePickupRadio').filter(':checked');
			const selectedOption = $selectedShippingOptionRadio.val();

			this.model.trigger('changeStore', e, selectedOption);

			$('body').lpModalClose();

		},
		showStoreRegionsDropdown () {

			const that = this;
			const $jsStoreRegions = this.ui.jsStoreRegions;
			const generateStoreRegionsDropdown = () => {

				const regionOptions = storeRegionsData.map(
					(region) => `<option value="${region.RegionId}">${region.Text}</option>`
				);

				$jsStoreRegions.html(regionOptions.join(''));

			};

			if ($jsStoreRegions.children().length === 0) {

				if (!storeRegionsData) {

					getAllRetailStoreRegions().then((storeRegions) => {

						if ($.isArray(storeRegions)) {

							// insert empty option
							storeRegions.unshift({
								Text: '-- Retail Store Locations --',
								RegionId: ''
							});

							storeRegionsData = storeRegions;

							generateStoreRegionsDropdown();

						}

					});

				} else {

					generateStoreRegionsDropdown();

				}

			}

		},
		showStoreRegions (e) {

			const that = this;
			const selectedRegion = $(e.target).val();

			if (selectedRegion) {

				this.showStorePickupList(
					{
						ZipCode: '',
						PickupStoreNumber: this.model.get('PickUpStoreNumber'),
						ShortSku: this.model.get('ShortSku'),
						RegionId: selectedRegion
					},
					this.ui.jsStoreRegions.children().filter(':selected').text()
				).done(() => {

					that.ui.jsZipForStore.val('');
					that.setSubmitButtonState(false);

				});

			}

		},
		setSubmitButtonState (enabled) {

			this.ui.jsUpdateStorePickupBtn.prop('disabled', !enabled);

		}
	});

}());
